import React, { Component } from "react";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

import axios from "axios";
import { api_url } from "../../../js_assets/ConfigApp";
import { GetApi, PostApi } from "../../../js_assets/Network";

import CircularProgress from "@material-ui/core/CircularProgress";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import AppAdminContainer from "../AppAdminContainer";
import List from "@material-ui/core/List";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import Slide from "@material-ui/core/Slide";

import CloseIcon from "@material-ui/icons/Close";

import Schedule from "@material-ui/icons/Schedule";

import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = (theme) => ({
  divider: {
    width: "100%",
  },
  ButtonGuide: {
    backgroundColor: "#74cbc4",
    color: "white",
    "&:hover": {
      background: "#74cbc4",
    },
    margin: theme.spacing.unit * 0.5,
    padding: "4px 5px",
    borderRadius: "5px",
    fontSize: 15,
    boxShadow: " 0 4px 8px 0 rgba(0,0,0,0.2);",
    fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
  },
  iocns: {
    fontSize: 18,
  },
  canceliocn: {
    color: "black",
    float: "left",
  },
  p_followUp_Schedule_Description: {
    maxWidth: 270,
    lineHeight: "2.7em",
  },
  ButtonSubscription: {
    backgroundColor: "#74cbc4",
    color: "white",
    "&:hover": {
      background: "#74cbc4",
    },
    fontSize: 15,
    boxShadow: " 0 4px 8px 0 rgba(0,0,0,0.2);",
    fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
  },
  btn_login: {
    color: "white",
    padding: "10px 1px",
    border: "none",
    cursor: "pointer",
    width: "100%",
    opacity: "0.9",
    borderRadius: "3px",
    fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
  },
});

class ListContactUsUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contact_us_data: [],
      loading_state_iocn: true,
      error_message_state: false,
      error_message_text: "",
      success_message_state: false,
      success_message_text: "",
      Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
    };
  }

  componentDidMount() {
    const { Admin_Info } = this.state;

    let Get_contact_us = GetApi(
      `/api/Admin/Get_contact_us/${Admin_Info.admin_Id}`,
      Admin_Info.jwT_Token_Admin
    );

    Get_contact_us.then((rep) => {
      //console.log(rep)

      this.setState({ contact_us_data: rep, loading_state_iocn: false });
    });
  }

  redirectToUrl = (Component) => {
    window.location.href =
      window.location.protocol +
      "//" +
      window.location.hostname +
      ":" +
      window.location.port +
      Component;
  };

  Delete_contact_us = (ID) => {
    const { Admin_Info } = this.state;

    let Delete_Item = GetApi(
      `/api/Admin/Delete_contact_us/${ID}/${Admin_Info.admin_Id}`,
      Admin_Info.jwT_Token_Admin
    );

    Delete_Item.then(() => {
      alert("تم الحدف");
    });
  };

  handleClose_error_message = () => {
    this.setState({ error_message_state: false, error_message_text: "" });
  };

  handleClose_success_message = () => {
    this.setState({ success_message_state: false, success_message_text: "" });
  };

  render() {
    const { classes } = this.props;
    const { contact_us_data, loading_state_iocn } = this.state;

    return (
      <AppAdminContainer Title={"الفزعة"}>
        <div style={{ marginTop: "7%", marginRight: "1%" }}>
          <div>
            {loading_state_iocn ? (
              <div className="centerloadingicon">
                <CircularProgress />
              </div>
            ) : contact_us_data.length == 0 ? null : (
              contact_us_data.map((trainer) => {
                return (
                  <div>
                    <div className="w3-cell-row">
                      <div className="w3-cell"></div>
                      <div className="w3-cell w3-container">
                        <h4>{trainer.userName}</h4>
                        <span> رقم الجوال</span> :{" "}
                        <span> {trainer.user_Phone} </span>
                        <br></br>
                        <span> التاريخ</span> :{" "}
                        <span> {trainer.contact_us_message_date} </span>
                        <br></br>
                        <hr></hr>
                        <p> {trainer.contact_us_message_content} </p>
                        <br></br>
                        <button
                          size={"large"}
                          variant="contained"
                          className={classes.ButtonGuide}
                          onClick={() => {
                            if (window.confirm("هل متاكد انك تبغى تحدف  ؟؟"))
                              this.Delete_contact_us(trainer.contact_us_id);
                          }}
                        >
                          حذف
                        </button>
                      </div>
                    </div>

                    <hr></hr>
                  </div>
                );
              })
            )}

            <Dialog
              open={this.state.error_message_state}
              onClose={this.handleClose_error_message}
              TransitionComponent={Transition}
              keepMounted
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle id="alert-dialog-slide-title">
                <div className="alertIconerror">
                  ⛔️ <label>{this.state.error_message_text} </label>{" "}
                </div>
              </DialogTitle>
            </Dialog>

            <Dialog
              open={this.state.success_message_state}
              onClose={this.handleClose_success_message}
              TransitionComponent={Transition}
              keepMounted
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle id="alert-dialog-slide-title">
                <div className="alertIcon">
                  ✔️ <label>{this.state.success_message_text} </label>{" "}
                </div>
              </DialogTitle>
            </Dialog>
          </div>
        </div>
      </AppAdminContainer>
    );
  }
}

ListContactUsUser.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListContactUsUser);
